<template lang="pug">
	.training-videos-list.padding.flex-col.space-large
		.font-large {{$tCaption('Explainer videos')}}
		Loader(v-if="isLoading", :fullscreen="true")
		.group.flex-col.space(v-for="group in trainingVideos")
			.font-big.bold {{group.name}}
			.flex-row.wrap
				.flex-col(v-for="video in group.videos")
					.training-video.flex-row.flex-1(@click="navigateToVideo(video)")
						.thumbnail(v-if="video.thumbnailUrl", :style="{ '--img': `url('${video.thumbnailUrl}')`}")
						.data.flex-row.space-medium.align-center
							fas(v-if="!video.thumbnailUrl", icon="play", size="2xl")
							.flex-col.space.center
								.font-big.accent-color {{video.Name}}
								span {{video.Description}}
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import axios from 'axios';

	export default {
	translationCategory: 'training-videos.List',
	components: { Loader },
	data() {
		return {
			trainingVideos: [],
			isLoading: false
		};
	},
	computed: {

	},
	mounted() {
		if (__DEBUG__)
			window.trainigVideos = this;
		this.loadData();
	},
	destroyed() {
		delete this.$trainingVideosPromise;
	},
	methods: {
		loadData() {
			this.isLoading++;
			this.$Data.getExternalApi('TrainingVideo/GetAllTrainingVideos', 'page=0', 9999).then(r => {
				const groups = _.groupBy(r.Results, (v) => v?.Category?.Name || '');
				this.trainingVideos = _.orderBy(Object.keys(groups), v => v).map(group => ({
					name: group,
					videos: groups[group]
				}));
				this.loadThumbnails();
			}).finally(() => this.isLoading--)
		}, 
		navigateToVideo(video) {
			this.$router.push({ path: `/training-videos/${video.Name}` });
		},
		loadThumbnails() {
			this.trainingVideos.map(g => g.videos.map(f => this.loadVideoThumbnail(f)));
		},
		loadVideoThumbnail(video) {
			if (video?.thumbnailUrl) return;

			const isVimeo = `${video?.Url}`.indexOf('vimeo') > -1;
			const isYoutube = ['y2u.be', 'youtube'].some(f => `${video?.Url}`.indexOf(f) > -1);

			if (__DEBUG__)
				console.debug('loadVideoThumbnail', { video, isVimeo, isYoutube });

			if (!(isVimeo || isYoutube)) return;

			if (isVimeo) {
				const items = `${video?.Url}`.split('/');
				const vimeoId = items[items.length - 1];
				axios.get(`https://vimeo.com/api/oembed.json?url=${video?.Url}`).then(r => {
					if (__DEBUG__)
						console.debug('thmb res', { r });
					if (r?.data?.thumbnail_url) {
						this.$set(video, 'thumbnailUrl', r?.data?.thumbnail_url);
					}
				})
			} else if (isYoutube) {
				const youtubeId = new URLSearchParams(`${video?.Url}`.split('?')[1]).get('v');
				this.$set(video, 'thumbnailUrl', `https://img.youtube.com/vi/${youtubeId}/0.jpg`)
			}
		}
	}
};
</script>
<style lang="scss">
	.training-videos-list {
		.training-video {
			background: #fff;
			cursor: pointer;
			border-radius: 4px;
			box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
			transform: scale(1);
			transition: 0.3s;
			margin: 10px;
			overflow: hidden;

			&:hover {
				transform: scale(1.05);
			}

			> .data {
				padding: 20px;
				max-width: 400px;
			}

			.thumbnail {
				min-width: 160px;
				height: 100%;
				background: var(--img);
				background-size: cover;
				background-position: center;
				border-radius: 4px 0px 0px 4px;
			}
		}
	}
</style>
